<template>
    <div class="vt-form-element">
        {{element.placeholder}}
        <template v-if="element.type === 'el-input'">
            <el-input
                    :key="element.id"
                    class="data-name public-margin-right-10"
                    :placeholder="element.placeholder"
                    v-model="element.model"
                    :disabled="element.disabled"
                    :size="element.size"
            ></el-input>
        </template>
        <template v-else-if="element.type === 'el-select'">
            <el-select
                    :key="element.id"
                    class="type-select public-margin-right-10"
                    v-model="element.model"
                    :placeholder="element.placeholder"
                    :disabled="element.disabled"
                    :size="element.size"
            >
                <template v-if="element.optionsIsArray">
                    <el-option
                            v-for="item in element.options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    >
                    </el-option>
                </template>
                <template v-else>
                    <el-option
                            v-for="(value, key, index) in element.options"
                            :key="index"
                            :label="value"
                            :value="key"
                    >
                    </el-option>
                </template>
            </el-select>
        </template>
        <template v-else-if="element.type === 'el-cascader'">
            <el-cascader
                    class="type-cascader public-margin-right-10"
                    v-model="element.model"
                    :placeholder="element.placeholder"
                    :options="element.options"
                    :props="element.props"
                    :disable="element.disabled"
                    :show-all-levels="element.showAllLevels"
                    :size="element.size"
            >
            </el-cascader>
        </template>
        <template v-else-if="element.type === 'el-button'">
            <el-button
                    :key="element.id"
                    type="primary"
                    size="mini"
                    :disabled="element.disabled"
                    class="public-sq-btn-primary"
                    @click="element.method(getSearchFormInputList, getSearchForm, element)"
            >
                <template v-if="element.icon">
                    <i class="iconfont" v-html="element.icon"></i>
                </template>
                <template v-else-if="element.laybel">{{ element.laybel }}</template>
            </el-button>
        </template>
    </div>
</template>

<script>
	export default {
		inject: ['getSearchForm', 'getSearchFormInputList'],
		data () {
			return {
				elementStandard: {
					type: 'el-input', // element-ui按钮类型
					placeholder: null,
					model: null,
					size: 'mini',
					options: [],
					optionsIsArray: false,
					disabled: true,
					showAllLevels: true,
					method: null,
					laybel: null,
					icon: null
                }
            };
		},
        computed: {
			elementComputed() {
				return Object.assign(this.elementStandard, this.element)
            }
        },
		props: {
			element: {
				type: Object,
				default: () => {
					return {};
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
    .vt-form-element {
        display: inline-block;
        margin: 0;
        padding: 0;
        .el-input {
            width: auto;
        }
        .el-button {
            margin-right: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/vt-search-form/vt-form-element/index.vue